import { ComponentType } from 'react';

import { SettingsSectionKey } from 'pages/SettingsV2/settingsTypes';
import { StoreConfigFlags } from 'types/settings/settingsApiTypes';
import ProductPriceSectionV2 from 'pages/SettingsV2/sections/programSettings/ProductPriceSectionV2';
import BarcodeSectionV2 from 'pages/SettingsV2/sections/programSettings/BarcodeSectionV2';
import WeightBarcodeSection from 'pages/SettingsV2/sections/programSettings/WeightBarcodeSection';
import DocumentSectionV2 from 'pages/SettingsV2/sections/programSettings/DocumentSectionV2';
import RoundingSectionV2 from 'pages/SettingsV2/sections/programSettings/RoundingSectionV2';
import LoyaltyPointsSectionV2 from 'pages/SettingsV2/sections/programSettings/LoyaltyPointsSectionV2';
import ServiceChargeSectionV2 from 'pages/SettingsV2/sections/programSettings/ServiceChargeSectionV2';
import InvoiceCodeSectionV2 from 'pages/SettingsV2/sections/programSettings/InvoiceCodeSectionV2';
import OrderPrintSection from 'pages/SettingsV2/sections/programSettings/OrderPrintSection';
import ServiceConnectionsSectionV2 from 'pages/SettingsV2/sections/serviceConnections/ServiceConnectionsSectionV2';

export type SettingsV2SectionKey =
  | SettingsSectionKey
  | 'weightBarcode'
  | 'orderPrint'
  | 'serviceConnections';

export interface SettingsSectionDef {
  key: SettingsV2SectionKey;
  labelKey: string;
  icon: string;
  groupKey: string;
  standalone?: boolean;
  visible: (flags: StoreConfigFlags, invEnabled: boolean) => boolean;
  component: ComponentType<any>;
}

export interface SettingsSectionGroupDef {
  key: string;
  labelKey: string;
  icon: string;
}

export const SETTINGS_SECTION_GROUPS: SettingsSectionGroupDef[] = [
  {
    key: 'programSettings',
    labelKey: 'Program Settings',
    icon: 'ri-settings-3-line',
  },
];

export const SETTINGS_SECTIONS: SettingsSectionDef[] = [
  {
    key: 'productPrice',
    labelKey: 'Product Price Settings',
    icon: 'ri-price-tag-3-line',
    groupKey: 'programSettings',
    visible: () => true,
    component: ProductPriceSectionV2,
  },
  {
    key: 'barcode',
    labelKey: 'Barcode Settings',
    icon: 'ri-barcode-line',
    groupKey: 'programSettings',
    visible: () => true,
    component: BarcodeSectionV2,
  },
  {
    key: 'weightBarcode',
    labelKey: 'Weight Barcode Settings',
    icon: 'ri-barcode-box-line',
    groupKey: 'programSettings',
    visible: () => true,
    component: WeightBarcodeSection,
  },
  {
    key: 'document',
    labelKey: 'Document Settings',
    icon: 'ri-file-text-line',
    groupKey: 'programSettings',
    visible: () => true,
    component: DocumentSectionV2,
  },
  {
    key: 'rounding',
    labelKey: 'Rounding Settings',
    icon: 'ri-coin-line',
    groupKey: 'programSettings',
    visible: (flags) => flags.show_rounding,
    component: RoundingSectionV2,
  },
  {
    key: 'loyaltyPoints',
    labelKey: 'Loyalty Points Settings',
    icon: 'ri-medal-line',
    groupKey: 'programSettings',
    visible: (flags) => flags.show_points,
    component: LoyaltyPointsSectionV2,
  },
  {
    key: 'serviceCharge',
    labelKey: 'Service Charge Settings',
    icon: 'ri-service-line',
    groupKey: 'programSettings',
    visible: (flags) => flags.show_service_charge,
    component: ServiceChargeSectionV2,
  },
  {
    key: 'invoiceCode',
    labelKey: 'Invoice Code Settings',
    icon: 'ri-hashtag',
    groupKey: 'programSettings',
    visible: (_flags, enabled) => enabled,
    component: InvoiceCodeSectionV2,
  },
  {
    key: 'orderPrint',
    labelKey: 'Order Print Settings',
    icon: 'ri-printer-line',
    groupKey: 'programSettings',
    visible: () => true,
    component: OrderPrintSection,
  },
  {
    key: 'serviceConnections',
    labelKey: 'Service Connections',
    icon: 'ri-links-line',
    groupKey: 'serviceConnections',
    standalone: true,
    visible: () => true,
    component: ServiceConnectionsSectionV2,
  },
];
